import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/landing/LegalPage";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: "Termos de Uso — Prime Saúde Benefícios" },
      { name: "description", content: "Termos de uso do site da Prime Saúde Benefícios." },
      { property: "og:title", content: "Termos de Uso — Prime Saúde Benefícios" },
      { property: "og:description", content: "Termos de uso do site da Prime Saúde Benefícios." },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <LegalPage title="Termos de Uso">
      <p>
        A Prime Saúde Benefícios atua na consultoria e comercialização de planos de saúde e não é
        operadora de planos de saúde.
      </p>
      <h2>Informações</h2>
      <p>
        As informações do site têm caráter informativo. Condições, valores, coberturas e
        disponibilidade dependem de cada operadora e são confirmados no momento da cotação.
      </p>
      <h2>Marcas</h2>
      <p>
        As marcas das operadoras pertencem aos seus respectivos titulares e são exibidas apenas para
        indicar as opções que podem ser consultadas.
      </p>
      <h2>Contato</h2>
      <p>Ao enviar seus dados, você autoriza o contato pelo WhatsApp para fins de cotação.</p>
    </LegalPage>
  ),
});
